<template>
  <div class="download" ref="downloadWrap">

    <div class="nick-info">
      <div class="avatar">
        <img :src="userInfo.avatar" alt="">
      </div>
      <div class="nickname"> {{userInfo.nickName}}</div>
      <div class="nickdes">{{lan.title}}</div>
    </div>
    <img class="invitebg" src="../assets/image12-3.png" alt="">
    <div class="copy" @click="copyToken($event)">
      {{lan.btn}}
    </div>
    <div class="tip">
      {{lan.tip}}
    </div>
    <canvas id="moveImg"></canvas>
    <img class="left-top" src="../assets/image/tuiyuan.png" alt/>
    <img class="right-bottom" src="../assets/image/square.png" alt/>

    <div class="mask" @click="show = false" v-show="show">
      <img class="arrow" src="../assets/arrow@3x.png" alt srcset/>
      <div class="know">请在外部浏览器打开</div>
    </div>

    <div class="mask-copy" @click="showCopy = false" v-show="showCopy">
      <div class="copy-token">
        <i class="el-icon-close close"></i>
        <div class="copy-title">{{lan.modalTitle}}</div>
        <div class="copy-content">
          {{userInfo.token}}
        </div>
        <div class="download-app" @click="download">
          {{lan.download}}
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Clipboard from 'clipboard'

export default {
  name: 'InviteFriends',
  data () {
    return {
      show: false,
      showCopy: false,
      ctx: null,
      animationObj: [],
      userInfo: {
        avatar: '',
        nickName: '',
        token: ''
      },
      lan: {
        title: '邀请您成为我的私密好友',
        btn: '复制私密口令 下载默往APP',
        tip: '密友口令仅支持默往V3.8.0及以上版本',
        modalTitle: '密友口令已复制',
        download: '马上下载默往App'
      },
      enLan: {
        title: 'Invite you to be a secret friend',
        btn: 'Copy your password and download it to your APP',
        tip: 'Secret friend password only supports silent access to V3.8.0 and above',
        modalTitle: 'The secret friend password has been copied',
        download: 'Download MO Messager  APP now'
      },
      hkLan: {
        title: '邀請妳成爲秘密好友',
        btn: '復制口令，下載默往APP',
        tip: '密友口令僅支持默往V3.8.0及以上版本',
        modalTitle: '密友口令已復制',
        download: '馬上下載默往APP'
      }
    }
  },
  created () {
    document.title = '邀请好友'
    this.userInfo.avatar = this.$route.query.a
    this.userInfo.nickName = this.$route.query.n
    this.userInfo.token = `#密友口令#长按复制这条消息，打开默往即可成为秘密好友$${this.$route.query.t}$`
    let { lan } = this.$route.params
    if (lan == 'en') {
      this.lan = this.enLan
    } else if (lan == 'zh_hk' || lan == 'zh_tw') {
      this.lan = this.hkLan
    }
  },
  methods: {
    copyToken (event) {
      const clipboard = new Clipboard(event.target, {
        text: () => this.userInfo.token
      })
      clipboard.on('success', () => {
        this.showCopy = true
        clipboard.destroy()
      })
      clipboard.on('error', () => {
        alert('复制失败')
        clipboard.destroy()
      })
      clipboard.onClick(event)
    },
    download () {
      if (this.isWeiXin()) {
        window.location.href = 'https://sj.qq.com/myapp/detail.htm?apkName=com.mostone.life'
        // this.show = true;
        return
      }
      // let channel = this.$route.query.channel;
      var u = window.navigator.userAgent
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      if (isIOS) {
        window.location.href = 'https://apps.apple.com/cn/app/id1408526658'
      } else {
        // if (channel) {
        //   window.location.href = `http://okimg.mostonetech.com/apks/mostone_release_${channel}.apk`;
        // } else {
        window.location.href =
              'http://okimg.mostonetech.com/apks/mostone_release.apk'
        // }
      }
    },
    openApp () {
      let type = this.$route.query.type
      let data = this.$route.query.data
      if (this.isWeiXin()) {
        this.show = true
      } else {
        window.location.href =
            'mostone://life.com/notice?type=' + type + '&data=' + data
      }
    },
    isWeiXin () {
      var ua = window.navigator.userAgent.toLowerCase()
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true
      } else {
        return false
      }
    },
    loop () {
      this.ctx.clearRect(0, 0, this.$refs.downloadWrap.clientWidth, this.$refs.downloadWrap.clientHeight)
      this.ctx.fillStyle = 'rgba(61, 249, 193, 0.1)'
      this.ctx.fillRect(0, 0, this.$refs.downloadWrap.clientWidth, this.$refs.downloadWrap.clientHeight)

      for (let i = 0; i < this.animationObj.length; i++) {
        this.animationObj[i].draw(this.ctx)
        this.animationObj[i].update(this.ctx)
      }
      requestAnimationFrame(this.loop)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "@/assets/css/style.scss";

  #moveImg {
    position: absolute;
    left: 0;
    top: 0;
    z-index: -1;
  }

  .download {
    width: 100%;
    margin: 0 auto;
    /*background-image: url("../assets/wap_bg.png");*/
    background-size: 100% 100%;
    background: rgba(61, 249, 193, 0.1);
    position: relative;
    overflow: hidden;

    .nick-info {
      text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: px2rem(110);

      .avatar {
        width: px2rem(110);
        height: px2rem(110);
        background: #c4c4c4;
        border-radius: 50%;
        border: solid #ffff px2rem(5);
        box-shadow: 0 0 px2rem(6) 0 #ddd;
        img{
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
      }

      .nickname {
        font-size: px2rem(28);
        padding: px2rem(12) 0;
      }

      .nickdes {
        font-weight: bold;
        font-size: px2rem(36);
      }
    }

    .invitebg {
      margin-top: px2rem(24);
      width: 100%;
    }

    .copy {
      width: px2rem(482);
      height: px2rem(100);
      border-radius: px2rem(300);
      color: #fff;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: px2rem(32);
      background: #00d394;
      margin: 0 auto;
      position: relative;
      top: px2rem(-50);

      &:active {
        background: #24e8ae;
      }
    }

    .tip {
      margin: 0 auto;
      color: #6D6F76;
      text-align: center;
      font-size: px2rem(22);
      position: relative;
      top: px2rem(-36);
    }

    .left-top {
      position: absolute;
      width: px2rem(400);
      left: px2rem(-160);
      top: px2rem(-40);
      z-index: -1;
      /*animation: rotateLeft 15s linear infinite;*/
    }

    .right-bottom {
      position: absolute;
      width: px2rem(400);
      right: px2rem(-160);
      bottom: px2rem(-40);
      z-index: -1;
      /*animation: rotateRight 15s linear infinite;*/
    }

    @keyframes rotateLeft {
      0% {
        transform: rotate(0);
        left: -120px;
        top: -20px;
      }
      50% {
        left: -20px;
        top: -120px;
        transform: rotate(180deg);
      }
      100% {
        transform: rotate(360deg);
        left: -120px;
        top: -20px;
      }
    }

    @keyframes rotateRight {
      0% {
        right: -120px;
        bottom: -20px;
      }
      50% {
        right: -20px;
        bottom: -120px;
      }
      100% {
        right: -120px;
        bottom: -20px;
      }
    }

    .mask, .mask-copy {
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background: rgba($color: #000000, $alpha: 0.7);
      color: #fff;
      z-index: 100000;

      .copy-token {
        width: px2rem(600);
        border-radius: px2rem(32);
        background: #fff;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        padding: px2rem(36);
        box-sizing: border-box;
        text-align: center;

        .copy-title {
          width: 80%;
          margin: 0 auto;
          color: #000;
          font-size: px2rem(32);
        }

        .copy-content {
          color: #6D6F76;
          background: #f4f4f4;
          padding: px2rem(12);
          box-sizing: border-box;
          border-radius: px2rem(32);
          font-size: px2rem(32);
          line-height: 1.5;
          text-align: left;
          margin-top: px2rem(32);
          word-break: break-all;
        }

        .download-app {
          width: px2rem(400);
          height: px2rem(100);
          border-radius: px2rem(300);
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: px2rem(32);
          background: #00d394;
          margin: 0 auto;
          margin-top: px2rem(24);

          &:active {
            background: #24e8ae;
          }
        }
        .close{
          position: absolute;
          right: px2rem(32);
          top: px2rem(40);
          color: #000;
          font-size: px2rem(40);
          font-weight: bold;
        }
      }

      .arrow {
        position: absolute;
        top: 10px;
        right: 10px;
        width: 60px;
      }

      .know {
        display: flex;
        position: absolute;
        right: 50px;
        top: 80px;
        font-size: 16px;
        color: #fff;
      }
    }
  }
</style>
